/**
 * Checks if a string or array length is zero, or if an object's properties are empty.
 * If the type is none of those above, it does a check for its existence.
 * */
function isEmpty(value?: string | object | undefined | null) {
  if (typeof value === 'string') {
    return value.trim().length === 0
  }

  if (Array.isArray(value)) {
    return value.length === 0
  }

  if (typeof value === 'object' && value !== null) {
    return Object.keys(value).length === 0
  }

  return !value
}

export { isEmpty }
